import { Component, OnInit } from '@angular/core';
import { faRulerHorizontal } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-contrastaria',
    templateUrl: './contrastaria.component.html',
    styleUrls: ['./contrastaria.component.less'],
    standalone: false
})
export class ContrastariaComponent implements OnInit {

  faHorizontalRule = faRulerHorizontal;

  constructor() { }

  c2021: string = "../../assets/images/contrastaria/contrastaria2021.png";

  c2015: string = "../../assets/images/contrastaria/contrastaria2015.jpg";

  c1998: string = "../../assets/images/contrastaria/contrastaria1998.jpg";

  c1985: string = "../../assets/images/contrastaria/contrastaria1985.jpeg";

  c1938: string = "../../assets/images/contrastaria/contrastaria1938.jpeg";

  c1887: string = "../../assets/images/contrastaria/contrastaria1887.jpeg";

  sel: string = "";

  cur: string = this.c1998;

  display: boolean = false;

  ngOnInit() {
  }

  swapList(it: string) {
    this.cur = it;
  }

  setSel(it: string) {
    this.sel = it;
    this.display = true;
    console.log("reached");
  }

}
